import { Delete, Edit } from "@mui/icons-material";
import { createGenericColumns, createRowsData } from "../../utils/tableUtils";

export const createIrrigationRowsData = createRowsData("irrigationName");

export const createIrrigationColumns = (actions) =>
  createGenericColumns({
    nameField: "irrigationName",
    nameHeader: "Nome Tipologia",
    actions,
    nameMinWidth: 200,
  });

export const getIrrigationActions = ({
  navigate,
  routerPaths,
  setSelectedIrrigationType,
  setSelectedAction,
  setDialogOpen,
}) => [
  {
    icon: Edit,
    tooltip: "Modifica",
    onClick: (rowId) => navigate(`${routerPaths.updateIrrigation}/${rowId}`),
  },
  {
    icon: Delete,
    tooltip: "Elimina",
    onClick: (rowId) => {
      setSelectedIrrigationType(rowId);
      setSelectedAction("delete");
      setDialogOpen(true);
    },
  },
];
